import React from 'react';

const Modal = props => {
   const { children, onClose } = props;

   return (
      <div className="product-modal">
         <div className="product-modal-content">
            <button className="close-modal" onClick={onClose}>
               <i className="fas fa-times" />
            </button>
            {children}
         </div>
      </div>
   );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal.js